import React from "react";
import {
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    Skeleton,
    Divider,
    List,
    ListItem,
    ListItemText
} from "@mui/material";
import ErrorView from "../ErrorView/ErrorView";
import classes from "./DataTable.module.css";
import MUIButton from "../UI/MUIButton/MUIButton";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import InputSelectionComponent from "../../luminaire/Dashboard/Component/inputSelection";
import { useState } from "react";
import { useEffect } from "react";

const CONTENT_MAP_LLM_OPTIONS = [
    {
        name: "gpt-4o",
        value: "gpt-4o",
        model: "gpt-4o",
    },

    {
        name: "Claude-3.5",
        value: "Claude3",
        model: "claude-3-5-sonnet-20240620",
    },
    {
        name: "Gemini-2.0",
        value: "Gemini",
        model: "gemini-2.0-flash",
    },
    {
        name: "Llama-3",
        value: "llama3",
        model: "llama-3-70B-Instruct",
    },
];

const ContentMapAnalysis = ({
    data,
    loading,
    error,
    title,
    key,
    getBuyingJourneyData,
    summary,
    handleContentMapping,
    isDisabled,
    selectedContentMapLlmItems,
    handleContentMapLlmCheckChange,
    items
}) => {
    const [filter, setFilter] = useState([]);
    const [contentData, setContentData] = useState([]);

    useEffect(() => {
        if (data && data.length > 0) {
            setContentData(data);
        }
    }, [data]);
    function LoadingSkeletion() {
        return (
            <div className="p-3">
                <Skeleton variant="rectangular" height={30} />
                {Array(10)
                    .fill(0)
                    .map((_, index) => (
                        <Skeleton
                            variant="rectangular"
                            width={index % 2 === 0 ? "70%" : "97%"}
                            key={index}
                            className="my-3"
                            height={20}
                        />
                    ))}
            </div>
        );
    }

    const handleFilterChange = (selected) => {
        const selectedValues = selected?.map((option) => option?.name) || [];
        let data1 = [...data];
        if (selectedValues && selectedValues.length > 0) {
            data1 = data1?.filter((obj) => selectedValues.includes(obj?.type));
        }

        setFilter(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
        setContentData(data1);
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px", // Space between elements
                    padding: "4px 0", // Minimal top & bottom padding
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        style={{ margin: 0, width: "365px" }}
                    >
                        {title}
                    </Typography>
                    <div
                        style={{ marginTop: "18px", width: "300px" }}
                        className=" customTabContent   col-md-3 position-relative"
                    >
                        <div className="input-group input-group-lg mb-3">
                            <span className="input-group-text" id="basic-addon1">
                                <i className="feather icon-target"></i>
                            </span>

                            <InputSelectionComponent
                                selectedOptions={selectedContentMapLlmItems}
                                handleChange={handleContentMapLlmCheckChange}
                                options={CONTENT_MAP_LLM_OPTIONS}
                                type="content_map_llm"
                            />
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <MUIButton
                        onClick={handleContentMapping}
                        variant="outlined"
                        className={classes.regenerate}
                        startIcon={<AutoAwesomeOutlinedIcon />}
                        disabled={isDisabled}
                        style={{ height: "40px", whiteSpace: "nowrap" }} // Optional compact height
                    >
                        Generate
                    </MUIButton>
                </div>
            </div>

            {error && (
                <div className={classes.error}>
                    <ErrorView
                        title={"Error fetching data !"}
                        message={error}
                        retry
                        onRetry={() => getBuyingJourneyData(key)}
                    />
                </div>
            )}
            {loading && !error && <LoadingSkeletion />}
            {!loading && !error && data?.length > 0 && (
                <Card sx={{ m: 3, boxShadow: 3, borderRadius: 4 }}>
                    <div
                        style={{
                            marginTop: "18px",
                            marginLeft: '60%',
                            width: "400px",
                        }}
                        className=" customTabContent col-md-3 position-relative"
                    >
                        {/* <div className="input-group input-group-lg mb-3">
                            <span className="input-group-text" id="basic-addon1">
                                <i className="feather icon-target"></i>
                            </span>

                            <InputSelectionComponent
                                selectedOptions={filter}
                                handleChange={handleFilterChange}
                                options={filterOptions}
                                type="content_map_llm"
                            />
                        </div> */}
                    </div>
                    <CardContent>
                        <TableContainer component={Paper} elevation={0}>
                            <Table sx={{ minWidth: 650 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#4fd1c5" }}>
                                        <TableCell align="center" sx={{ color: "#fff" }}>
                                            Major Discussion Topic
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: "#fff" }}>
                                            Coverage Statue
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: "#fff" }}>
                                            URL(s)
                                        </TableCell>
                                        <TableCell align="center" sx={{ color: "#fff" }}>
                                            Action Needed?
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {contentData?.map((row, index) => (
                                        <TableRow
                                            key={row?.name}
                                            sx={{
                                                backgroundColor:
                                                    index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                                            }}
                                        >
                                            <TableCell align="center">{row?.topic}</TableCell>
                                            <TableCell align="center">{row?.coverageStatus}</TableCell>
                                            <TableCell align="center">
                                                {row?.url ? (
                                                    <a
                                                        href={row.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "#1976d2", textDecoration: "none" }}
                                                    >
                                                        {row.url}
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>

                                            <TableCell align="center">{row?.actionNeeded}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            )}

            {(summary || (items && items.length > 0)) && <Card sx={{ m: 3, boxShadow: 3, borderRadius: 4 }}>
                <CardContent>
                    <h5> Summary </h5>
                    <Typography variant="body1" gutterBottom>
                        {summary}
                    </Typography>

                    {/* Separator */}
                    <Divider sx={{ my: 2 }} />

                    <h5> Recommended Next Steps </h5>
                    <List dense>
                        {items?.map((item, index) => (
                            <ListItem key={index} sx={{ py: 0 }}>
                                <ListItemText
                                    primaryTypographyProps={{ variant: "body2" }}
                                    primary={`• ${item}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                </CardContent>
            </Card>}


        </>
    );
};

export default ContentMapAnalysis;